import IamRouter from '@IAM/router'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'
import { featureMenuHiddenCheck } from '@/utils/auth'
import Layout from '@/layouts/RouterView'
import Organization from '@IAM-ee/views/organization'
import i18n from '@/locales'
import store from '@/store'

export default {
  index: 91,
  meta: {
    label: i18n.t('scope.text_959'),
    icon: 'menu-iam',
  },
  menus: IamRouter.menus.map((item, index) => {
    if (index === 0) {
      const [first, ...last] = item.submenus
      item.submenus = [
        first,
        {
          path: '/organization',
          meta: {
            label: i18n.t('iamee.organization'),
            permission: 'organizations_list',
            t: 'iamee.organization',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.organization')) {
                return true
              }
              if (!store.getters.isAdminMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'Organization',
              path: '',
              component: Organization,
            },
          ],
        },
        ...last,
      ]
    }
    return item
  }),
}
